module.exports = __webpack_public_path__ + "img/HZG_Logo_50_RGB.a89bca4c.png";